import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { Filter } from '@docpath/linces-angular-components/common';
import { DpPaginationModule, DpTableModule, Table } from '@docpath/webcomponents';

import { MonitoringService } from '../../services/monitoring.service';
import { MonitoringHttpService } from '../../services/monitoring-http.service';
import { MonitoringTableService } from './monitoring-table.service';

@Component({
  selector: 'app-monitoring-table',
  templateUrl: './monitoring-table.component.html',
  standalone: true,
  imports: [DpTableModule, DpPaginationModule]
})
export class MonitoringTableComponent implements OnInit {
  @Input() filters: Filter[] = [];
  @Output() selectedRow = new EventEmitter<void>();
  @Output() tableLoaded = new EventEmitter<Table>();

  table: Table;
  showLoading = false;

  @Input() dgeId!: number;

  private readonly monitoringTableService = inject(MonitoringTableService);
  private readonly monitoringService = inject(MonitoringService);
  private readonly monitoringHttpService = inject(MonitoringHttpService);

  constructor() {
    this.table = this.monitoringTableService.initTable();
  }

  ngOnInit(): void {
    this.monitoringService.dgeChanged.subscribe(dgeId => {
      this.dgeId = dgeId;

      this.monitoringTableService.loadAlerts(this.dgeId, [], 1, 25);
      this.tableLoaded.emit(this.table);
    });

    this.monitoringTableService.alertsLoaded.subscribe(result => {
      this.table.header = this.monitoringTableService.initTableHeader();
      this.table.body = this.monitoringTableService.initTableBody(result);
    });

    this.monitoringHttpService.showLoadingTableChanged.subscribe(showLoading => {
      this.showLoading = showLoading;
    });

  }

  onChangePage(page: number): void {
    this.monitoringTableService.loadAlerts(this.dgeId, this.filters, page);
  }

  onChangePageSize(size: number): void {
    this.monitoringTableService.loadAlerts(this.dgeId, this.filters, 1, size);
  }

  getCurrentPage(): number {
    return this.monitoringTableService.getCurrentPage();
  }

  getCurrentSize(): number {
    return this.monitoringTableService.getCurrentSize();
  }

  getElements(): number {
    return this.monitoringTableService.getElements();
  }
}
